<template>
  <div class="checkout-total checkout-total-top">
    <button class="btn-green" @click="onNext">
      המשך
    </button>
  </div>
</template>

<script>
export default {
  name: "CheckoutTotalTop",
  props: {
    step: {
      type: Number,
      default: 1
    },
    totals: {
      type: Object,
      default: () => {
        return []
      }
    }
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    onNext() {
      this.$emit('next');
    }
  }
}
</script>

<style scoped>
.checkout-total.checkout-total-top {
  @media (max-width: 768px) and (min-width: 481px) {
    right: 0%;
  }
}
</style>
